import { useEffect, useState } from "react";
import Lenis from "lenis";
import { toast } from "sonner";
import { Header } from "../components/Header";
import { Hero } from "../components/Hero";
import { Marquee } from "../components/Marquee";
import { TripCard } from "../components/TripCard";
import { PaymentDialog } from "../components/PaymentDialog";
import { HowItWorks } from "../components/HowItWorks";
import { Reviews } from "../components/Reviews";
import { FAQ } from "../components/FAQ";
import { Footer } from "../components/Footer";
import { MobileBar } from "../components/MobileBar";
import { SectionHead } from "../components/Reveal";
import { useLang } from "../i18n/LanguageContext";
import { TRIP_ORDER } from "../lib/config";

export default function Home() {
  const { t } = useLang();
  const [order, setOrder] = useState(null);
  const [refreshKey, setRefreshKey] = useState(0);

  useEffect(() => {
    const lenis = new Lenis({ lerp: 0.09, smoothWheel: true });
    window.__lenis = lenis;
    let raf;
    const loop = (time) => { lenis.raf(time); raf = requestAnimationFrame(loop); };
    raf = requestAnimationFrame(loop);
    return () => { cancelAnimationFrame(raf); lenis.destroy(); window.__lenis = null; };
  }, []);

  useEffect(() => { document.documentElement.lang = t.code; }, [t.code]);

  const onBooked = (b) => {
    setRefreshKey((k) => k + 1);
    toast.success(`${t.voucher.title} ${b.code}`);
  };

  return (
    <main className="min-h-screen overflow-x-clip">
      <Header />
      <Hero />
      <Marquee />
      <section id="trips" className="bg-[var(--paper)] py-24 sm:py-32" data-testid="trips-section">
        <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
          <SectionHead eyebrow={t.trips.eyebrow} title={t.trips.title} sub={t.trips.sub} />
          <div className="mt-14 grid gap-6 lg:grid-cols-3 lg:gap-7">
            {TRIP_ORDER.map((id, i) => <TripCard key={id} id={id} index={i} onPay={setOrder} refreshKey={refreshKey} />)}
          </div>
        </div>
      </section>
      <HowItWorks />
      <Reviews />
      <FAQ />
      <Footer />
      <MobileBar />
      <PaymentDialog order={order} onClose={() => setOrder(null)} onBooked={onBooked} />
    </main>
  );
}
